import './App.css';
import Home from './Components/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Services from './Components/Services';
import Strategy from './Components/Strategy';
import ScrollToTop from './Components/ScrollToTop';
import Contact from './Components/Contact';
import Solutions from './Components/Solutions';
import Profile from './Components/Profile';
import { useEffect, useState } from 'react';
import MobileView from './Components/MobileView';
import Dashboard from './Components/Dashboard';
import Projects from './Components/Projects';
import CreativeTokens from './Components/CreativeTokens';
import Dashboard2 from './Components/Dashboard2';

import './css/media.css'
import Login from './Components/Login';
import Singup from './Components/Signup';
import Article from './Components/Article';
import CreateProjectForm from './Components/CreateProjectForm';
import ProjectDetailsPage from './Components/ProjectDetailsPage';
import BlogPage from './Components/BlogPage';
import BlogDetailPage from './Components/BlogDetailPage';
import TeamPage from './Components/TeamPage';
import CareerPage from './Components/CareerPage';
import CollaborationsPage from './Components/CollaborationsPage';
import InvestorsPage from './Components/InvestorsPage';
import ComingSoon from './Components/ComingSoon';
import Environment from './Components/Environment';
import PrivacyPage from './Components/PrivacyPage';
import HelpSupport from './Components/HelpSupport';
import CreateTicket from './Components/CreateTicket';
import ReferralsPage from './Components/ReferralsPage';

function App() {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <Router>
      <ScrollToTop/>
        <Routes>
          {/* <Route path='/' element={isMobile ? <MobileView/> : <Home/>}/> */}
          <Route path='/' element={<Home/>}/>
          <Route path='/services' element={<Services/>}/>
          <Route path='/solutions' element={<Solutions/>}/>
          <Route path='/solutions/:scolor' element={<Solutions/>}/>
          <Route path='/strategy' element={<Strategy/>}/>
          <Route path='/profile' element={<Profile/>}>
            <Route path='/profile' element={<Dashboard/>}/>
            <Route path='/profile/projects' element={<Projects/>}/>
          </Route>
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/login' element={<Login/>}/>
          <Route path='/signup' element={<Singup/>}/>
          <Route path="/article/:id" element={<Article />} />
          <Route path="/creative-tokens" element={<CreativeTokens />} />
          <Route path="/dashboard2" element={<Dashboard2 />} />
          <Route path="/createprojectform" element={<CreateProjectForm />} />
          <Route path="/blogpage" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/teampage" element={<TeamPage />} />
          <Route path="/careerpage" element={<CareerPage />} />
          <Route path="/collabpage" element={<CollaborationsPage />} />
          <Route path="/investorpage" element={<InvestorsPage />} />
          <Route path="/comingsoon" element={<ComingSoon />} />
          <Route path="/environment" element={<Environment />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/helpsupport" element={<HelpSupport />} />
          <Route path="/createticket" element={<CreateTicket />} />
          <Route path="/referrals" element={<ReferralsPage />} />


          <Route path="/project/:id" element={<ProjectDetailsPage />} />
        </Routes>
    </Router>
  );
}

export default App;